import { Injectable } from '@angular/core';

import { Logger, LoggerService } from './../../../api';
import { le, li, lw } from './logger.service';

/* Copyright IBM Corp. 2017 */
/**
 * Constructs a proxy around our logger
 *
 * @param aName the name of the loger
 * @return the proxy
 */
function _createLoggerProxy(aName: string): Logger {
    return {
        'info': li.bind(undefined, aName),
        'warn': lw.bind(undefined, aName),
        'error': le.bind(undefined, aName)
    };
}

@Injectable({ providedIn: 'root' })
export class WchLoggerService implements LoggerService {

    get: (name: string) => Logger;

    constructor() {

        const that = this;

        // registry of loggers
        const _registry: { [key: string]: Logger } = {};

        function _getLogger(aName: string): Logger {
            // assign
            return _registry[aName] || (_registry[aName] = _createLoggerProxy(aName));
        }

        // assign
        that.get = _getLogger;
    }
}
